const subMenus = [
  {
    id: "m-1",
    title : "Outlet yang terintegrasi",
    subTitle: "outlet",
  },
  {
    id: "m-2",
    title : "Riwayat pengiriman pesan",
    subTitle: "Terakhir pengiriman",
  },
  {
    id: "m-3",
    title : "Riwayat pembelian paket",
    subTitle: "Terakhir pembelian",
  },
]
export default subMenus;
